/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DbrBalloonCodeResponseDto } from '../../models/dbr-balloon-code-response-dto';

export interface BalloonsControllerFindLastCode$Params {
}

export function balloonsControllerFindLastCode(http: HttpClient, rootUrl: string, params?: BalloonsControllerFindLastCode$Params, context?: HttpContext): Observable<StrictHttpResponse<DbrBalloonCodeResponseDto>> {
  const rb = new RequestBuilder(rootUrl, balloonsControllerFindLastCode.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DbrBalloonCodeResponseDto>;
    })
  );
}

balloonsControllerFindLastCode.PATH = '/balloons/last-code';
